'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _video = require('./remote/video');

var Video = {
    fetchStreamId: _video.VideoRemote.fetchStreamId
};

exports.default = Video;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/video.js
// module id = qRRx
// module chunks = 60